import { defineMessages } from 'react-intl';

export default defineMessages({
  charityVettingDecreePublicationDatesTitleFR: {
    id: 'charity.vetting.fr.decree.publication.dates.title',
    defaultMessage: 'What are the publication dates of your decree and its Official Journal entry?',
  },
  charityVettingDecreePublicationDateLabelFR: {
    id: 'charity.vetting.fr.decree.publication.date.label',
    defaultMessage: 'Date of decree',
  },
  charityVettingOfficialJournalPublicationDateLabelFR: {
    id: 'charity.vetting.fr.official.journal.publication.date.label',
    defaultMessage: 'Date of Official Journal publication',
  },
  charityVettingDecreePublicationDatePlaceholderFR: {
    id: 'charity.vetting.fr.decree.publication.date.placeholder',
    defaultMessage: 'Choose the date',
  },
  charityVettingDecreePublicationDateRequiredFR: {
    id: 'charity.vetting.fr.decree.publication.date.required',
    defaultMessage: 'Please provide the date of your decree',
  },
  charityVettingOfficialJournalPublicationDateRequiredFR: {
    id: 'charity.vetting.fr.official.journal.publication.date.required',
    defaultMessage: 'Please provide the date it was published in the Official Journal',
  },
});

// French legal subtitle — not wrapped in defineMessages to prevent i18n extraction
export const frenchOptions = {
  charityVettingDecreePublicationDatesSubtitleFR: {
    id: 'charity.vetting.fr.decree.publication.dates.subtitle',
    defaultMessage: "Association ou fondation reconnue d'utilité publique par décret",
  },
} as const;
